import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { blogService } from '../../services/blogService';

export const useGetBlogBanners = () => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    queryKey: [QUERY_KEYS.blog.banners],
    queryFn: () =>
      blogService.banners().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data.list;
        }
        return [];
      }),
  });
};
